import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@material-ui/core';
import { connect } from 'react-redux';
import GlobalStyles from 'src/components/GlobalStyles';
import theme from 'src/theme';
import routes from 'src/routes';
import messagesDe from './translations/de.json';
import messagesEn from './translations/en.json';
import messagesRu from './translations/ru.json';
import { getUser } from './redux/reducers/user/selectors';

const messages = {
  de: messagesDe,
  en: messagesEn,
  ru: messagesRu,
};

const App = ({ user }) => {
  const routing = useRoutes(routes(localStorage.getItem('token')));

  return (
    <IntlProvider
      locale={user?.locale?.split(/[-_]/)[0] || navigator.language.split(/[-_]/)[0]}
      messages={messages[user?.locale?.split(/[-_]/)[0] || navigator.language.split(/[-_]/)[0]]}
      defaultLocale="en"
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {routing}
      </ThemeProvider>
    </IntlProvider>
  );
};

export default connect(getUser, {})(App);
